export function getOrgId (org) {
  return org.id || org._id
}
